export default __webpack_public_path__ + "static/PlayfairDisplay-Black-5450ea5a539a7377cb5141dec156dfa4.woff2";